export default __webpack_public_path__ + "static/media/PostePay.55575147.svg";